import { Check } from 'lucide-react';
import type { ReactElement } from 'react';
import { formatDate } from '@/shared/lib';

interface VerificationRowProps {
  readonly label: string;
  /** 인증 시각(ISO) — 아직이면 null. */
  readonly verifiedAt: string | null;
}

/** 인증 상태 한 줄 — 완료면 체크와 날짜, 아직이면 "인증 필요". */
export const VerificationRow = ({ label, verifiedAt }: VerificationRowProps): ReactElement => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-2 py-3">
    <dt className="w-28 shrink-0 text-sm text-muted-foreground">{label}</dt>
    <dd className="flex min-w-0 flex-1 flex-wrap items-center justify-between gap-3 text-sm">
      {verifiedAt !== null ? (
        <span className="inline-flex items-center gap-2">
          <span className="inline-flex size-5 items-center justify-center bg-brand-lime text-black">
            <Check aria-hidden className="size-3.5" strokeWidth={2.5} />
          </span>
          인증 완료
          <span className="text-muted-foreground tabular-nums">{formatDate(verifiedAt)}</span>
        </span>
      ) : (
        <span className="inline-flex h-6 items-center border border-foreground/20 px-2 text-xs font-semibold">
          인증 필요
        </span>
      )}
    </dd>
  </div>
);
